import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useLinkStyles = makeStyles()(({ palette }: Theme) => ({
  root: {
    cursor: 'pointer',
    color: palette.proceed.main,
    display: 'block',
  },
}));

export const usePaperStyles = makeStyles()(({ palette, spacing }: Theme) => ({
  root: {
    backgroundColor: palette.background.default,
    padding: spacing(2),
    marginBottom: spacing(2),
  },
}));

export const usePhoneNumberStyles = makeStyles()({
  root: {
    whiteSpace: 'nowrap',
  },
});
